<script>
    export default {
        name: 'TodoItem',
        props: {
            img: {
                type: String,
                required: false,
                default: ''
            },
            status: {
                required: false,
                default: ''
            },
            name: {
                type: String,
                required: false,
                default: ''
            },
            app: {
                type: String,
                required: false,
                default: ''
            },
            link: {
                type: String,
                required: false,
                default: ''
            },
            theme: {
                type: String,
                required: false,
                default: 'panel'
            },
            disabled: {
                type: Boolean,
                required: false,
                default: false
            }
        },
        computed: {
            compLink () {
                return this.disabled ? `javascript:;` : this.link;
            },
            compTarget () {
                return this.disabled ? `` : '_blank';
            }
        },
        methods: {
            handleFavClick ($e) {
                $e.stopPropagation();
                $e.preventDefault();
                this.$emit('app-fav-click');
            }
        }
    };
</script>

<template>
    <a :target="compTarget"
       :href="compLink"
       class="app-item"
       :class="[theme, {'is-disabled':disabled}]">
        <img :src="img" alt="">
        <div class="app-item_base">
            <template v-if="theme === 'reverse' || theme === 'center-item'">
                <p>{{ app }}</p>
                <span v-if="name">{{ name }}</span>
            </template>
            <template v-else>
                <span v-if="name">{{ name }}</span>
                <p>{{ app }}</p>
            </template>
        </div>
        <i class="fav"
           @click.stop="handleFavClick"
           v-if="theme === 'modal-theme'"
           v-html="status ? '&#xe640;' : '&#xe643;'"></i>
    </a>
</template>

<style lang="less" scoped>
    @import '../../../southcn-ui2/src/assets/less/widgets-var';

    a {
        text-decoration: none;
    }

    .app-item {
        display: flex;
        float: left;
        align-items: center;
        justify-content: flex-start;
        cursor: pointer;
        transition: background-color .2s ease;
        box-sizing: border-box;


        &.is-disabled {
            background-color: transparent !important;
            filter: grayscale(100%);
            opacity: 0.8;
            cursor: not-allowed !important;
            /*i {*/
            /*display: none !important;*/
            /*}*/
        }

        &.can-move {
            cursor: move;

        }

        &.reverse {
            &:hover {
                background-color: #fff;
            }
        }

        &:hover {
            background-color: @otherBtnHoverClr;

            &.modal-theme {

                &.can-move {
                    i {
                        display: none;
                    }
                }

                i {
                    display: inline-block;
                }
            }
        }

        &.modal-theme {
            width: 228px;
            border: 1px solid @otherBorderClr;
            height: 60px;
            padding-left: 13px;
            padding-right: 10px;

            img {
                width: 36px;
                height: 36px;
                border-radius: 3px;
                margin-right: 14px;
            }

            i {
                display: none;
                font-family: cmsicon;
                color: @warnBg;
                font-style: normal;
                font-size: @fontSizeContent;
                cursor: pointer;
            }

            .app-item_base {
                width: calc(100% - 68px);
                min-width: 1px;

                > span {
                    display: inline-block;
                    font-size: @fontSizeNote;
                    color: @otherTextClr;
                    width: 100%;
                    line-height: 1;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }

                > p {
                    font-size: @fontSizeeBtnTableText;
                    color: @otherNormalTitleClr;
                    overflow: hidden;
                    line-height: 1;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
            }
        }

        &.reverse {
            width: 25%;
            height: 120px;
            padding: 0 10px;

            p {
                margin: 0;
            }

            span {
                margin: 6px 0 0 0;

            }
        }

        &.panel {
            width: 33.33333%;
            height: 120px;
            padding-left: 20.25% / 3;
            padding-right: 2.08%;
        }

        &.panel, &.reverse {


            img {
                width: 48px;
                height: 48px;
                border-radius: 5px;
                margin-right: 10px;
            }

            .app-item_base {
                width: calc(100% - 58px);
                flex: 1;
                min-width: 1px;

                > span {
                    display: inline-block;
                    font-size: @fontSizeNote;
                    color: @otherTextClr;
                    width: 100%;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }

                > p {
                    font-size: @fontSizeTableTitle;
                    color: @otherNormalTitleClr;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
            }
        }

        * {
            box-sizing: border-box;
        }


        &.center-item {
            flex-direction: column;
            max-width: 300px;
            height: 260px;
            background: #FFFFFF;
            box-shadow: 0px 4px 16px 0px rgba(148, 150, 153, 0.2);
            border-radius: 6px;
            align-items: center;
            justify-content: center;
            width: 100%;

            img {
                width: 70px;
            }

            .app-item_base {
                text-align: center;

                p {
                    padding: 20px 10px 15px 10px;
                    margin: 0;
                    font-size: 20px;
                    color: @otherBigTitleClr;
                }

                span {
                    font-size: 16px;
                    color: @otherTextClr;
                }
            }
        }
    }
</style>
